import styled, { keyframes } from 'styled-components';

const rotation = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

export const Wrapper = styled.div`
  width: 16px;
  height: 16px;
  overflow: hidden;

  & > div {
    width: 100%;
    height: 100%;
    border-style: solid;
    border-width: 3px;
    border-color: ${({ theme }): string => theme.palette_blue_5};
    border-bottom-color: ${({ theme }): string => theme.palette_blue_100};
    border-radius: 50%;
    box-sizing: border-box;
    animation: ${rotation} 1s linear infinite;
  }
`;
